import { FiMap, FiCreditCard, FiDollarSign } from "react-icons/fi";
import { FaPlaneDeparture, FaShip, FaHotel } from "react-icons/fa6";

export default function ServiceIconsStrip() {
  const items = [
    { key: "tour", icon: <FiMap className="h-5 w-5 text-sky-600" />, title: "Tour" },
    { key: "hotel", icon: <FaHotel className="h-5 w-5 text-sky-600" />, title: "Hotel" },
    { key: "travel", icon: <FaPlaneDeparture className="h-5 w-5 text-sky-600" />, title: "Travel" },
    { key: "visa", icon: <FiCreditCard className="h-5 w-5 text-sky-600" />, title: "Visa" },
    { key: "cruise", icon: <FaShip className="h-5 w-5 text-sky-600" />, title: "Cruise" },
    { key: "forex", icon: <FiDollarSign className="h-5 w-5 text-sky-600" />, title: "Forex" },
    { key: "flight", icon: <FaPlaneDeparture className="h-5 w-5 text-sky-600" />, title: "Flight" },
  ];

  return (
    <div className="mt-4 grid grid-cols-4 sm:grid-cols-7 gap-3 text-gray-600">
      {items.map((it) => (
        <div
          key={it.key}
          className="flex items-center justify-center rounded-xl border border-gray-200 bg-gray-50 p-3"
          title={it.title}
          aria-label={it.title}
        >
          {it.icon}
        </div>
      ))}
    </div>
  );
}
